import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'

import SaveAndExitButton from './SaveAndExitButton'
import styles from './styles.module.scss'

interface CreditApplicationPageLayoutProps {
  pageTitle: ReactNode
  marketing: ReactNode
  hideBackButton?: boolean
  onBackClick?: () => void
  onNextClick?: () => void
  nextButtonText?: ReactNode
  isNextButtonLoading?: boolean
  isNextButtonDisabled?: boolean
}
const CreditApplicationPageLayout = ({
  pageTitle,
  marketing,
  hideBackButton,
  onBackClick,
  onNextClick,
  children,
  nextButtonText,
  isNextButtonLoading = false,
  isNextButtonDisabled = false,
}: React.PropsWithChildren<CreditApplicationPageLayoutProps>) => {
  const [getClassName, _, getModuleClassName] = useNameFormatter('CreditApplicationPageLayout')

  return (
    <div className={`${styles[getClassName('')]} dd-privacy-allow`}>
      <div className={styles[getClassName('form')]}>
        <div className={styles[getClassName('content-container')]}>
          <div className={styles[getClassName('logo')]}>
            <BillBrandLogo />
          </div>
          <h1 className={getModuleClassName(styles, 'title')}>{pageTitle}</h1>
          <div className={styles[getClassName('content')]}>{children}</div>
        </div>
        <div className={styles[getClassName('footer')]}>
          <SaveAndExitButton />
          <div className={styles[getClassName('footer-navigation-buttons')]}>
            {!hideBackButton && (
              <BasicButton
                type={BASIC_BUTTON_TYPE_OUTLINED}
                onClick={onBackClick}
              >
                <FormattedMessage
                  defaultMessage='Back'
                  id='sputnik.CreditApplicationPageLayout__cyR7Kh'
                />
              </BasicButton>
            )}
            <BasicButton
              disabled={isNextButtonDisabled}
              showSpinner={isNextButtonLoading}
              onClick={onNextClick}
            >
              {nextButtonText ?? (
                <FormattedMessage
                  defaultMessage='Next'
                  id='sputnik.CreditApplicationPageLayout__9+Ddtu'
                />
              )}
            </BasicButton>
          </div>
        </div>
      </div>
      {marketing}
    </div>
  )
}

export default CreditApplicationPageLayout
